import Cookie from "js-cookie";
import { Navigate } from "react-router-dom";

export const Logout = (props) => {

  Cookie.remove("ut_user");
  Cookie.remove("ut_school");
  return <Navigate to={"/"} />;
};
